/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_photo_api_photos_upload_post } from '../models/Body_upload_photo_api_photos_upload_post';
import type { PhotoResponse } from '../models/PhotoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PhotosService {
    /**
     * User Photos
     * @returns PhotoResponse Successful Response
     * @throws ApiError
     */
    public static userPhotosApiPhotosListGet(): CancelablePromise<Array<PhotoResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/photos/list',
        });
    }
    /**
     * Upload Photo
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadPhotoApiPhotosUploadPost(
        formData: Body_upload_photo_api_photos_upload_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/photos/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Completed Upload
     * @returns any Successful Response
     * @throws ApiError
     */
    public static completedUploadApiPhotosCompletedUploadPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/photos/completed-upload',
        });
    }
    /**
     * Delete Photo
     * @param orderId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePhotoApiPhotosDeleteDelete(
        orderId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/photos/delete',
            query: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
